module.exports = __webpack_public_path__ + "static/media/implant.8417e2df.svg";